import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "../lib/router-context";
import { api } from "../lib/api";
import { ChallengeLobby } from "./daily";

/** `/play/daily/:language/:date`: a past daily, linked from its archive page. */
export function ReplayDailyPage() {
  const { t } = useTranslation();
  const { language, date } = useParams();
  const createLobby = useCallback(
    () => api.replayDaily(language, date),
    [language, date],
  );

  return (
    <ChallengeLobby
      createLobby={createLobby}
      loadingLabel={t("daily.loading")}
    />
  );
}

/** `/play/c/:publicId`: a custom challenge, linked from `/c/:publicId`. */
export function CustomChallengePlayPage() {
  const { t } = useTranslation();
  const { publicId } = useParams();
  const createLobby = useCallback(
    () => api.playCustomChallenge(publicId),
    [publicId],
  );

  return (
    <ChallengeLobby
      createLobby={createLobby}
      loadingLabel={t("daily.loading")}
    />
  );
}
